export default {"src":"/_next/static/media/yelp.2a83159f.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};